import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Obține raportul AI pentru o procedură SEAP.
 * @param {string} procedureId - Codul procedurii (ex: CN123456)
 * @returns {Promise<Object>} Răspunsul AI în format JSON
 */
export const fetchAIReport = async (procedureId) => {
  const token = Cookies.get('jwtToken');

  const response = await axios.get(
    `${BASE_URL}/api/AIReports/GenerateProcedureAIReport`,
    {
      params: { procedureId },
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  );

  return response.data;
};

/**
 * Obține raportul AI pentru o achiziție directă.
 * @param {string} noticeNo - Numărul achiziției directe
 * @returns {Promise<Object>} Răspunsul AI în format JSON
 */
export const fetchDirectAwardAIReport = async (noticeNo) => {
  const token = Cookies.get('jwtToken');
  const response = await axios.get(
    `${BASE_URL}/api/AIReports/GenerateDirectAwardAIReport`,
    {
      params: { noticeId: noticeNo },
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  );

  return response.data;
};
